(() => {
  const initEtrnlLenis = () => {
    if (!window.Lenis || window.etrnlLenis) return;

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    const lenis = new Lenis({
      autoRaf: true,
      autoToggle: true,
      anchors: true,
      stopInertiaOnNavigate: true,
      prevent: (node) => Boolean(
        node &&
        node.closest &&
        node.closest('.cart-drawer-layer,.search-modal-layer,.account-modal-layer,.mobile-menu-layer')
      )
    });

    window.etrnlLenis = lenis;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEtrnlLenis, { once: true });
  } else {
    initEtrnlLenis();
  }
})();
